import { useState, useEffect,useRef } from "react";
import Spinner from "../components/Spinner";
import axios from "axios";

const LogViewer = () => {
  const [downloads, setDownloads] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const pollInterval = useRef(null);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("token");
      const baseUrl = process.env.REACT_APP_API_URL || "";
      const url = `${baseUrl}/mailLogger/mailLoggerDownload`;

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDownloads(res.data.data || []);
    } catch (err) {
      setDownloads([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

   useEffect(() => {
    const anyProcessing = downloads.some(d => !d.link);

    if (anyProcessing && !pollInterval.current) {
      pollInterval.current = setInterval(fetchData, 5000);
    }

    if (!anyProcessing && pollInterval.current) {
      clearInterval(pollInterval.current);
      pollInterval.current = null;
    }

    return () => {
      if (pollInterval.current) {
        clearInterval(pollInterval.current);
        pollInterval.current = null;
      }
    };
  }, [downloads]);

  if (isLoading) return <Spinner />;

  return (
    <div className="flex flex-col m-2 lg:mx-10">
      <h1 className="font-semibold text-xl md:text-2xl text-gray-700 my-4 mb-6">
        Test Plan Export Download Section
      </h1>
      <div className="overflow-x-auto rounded-lg shadow border border-gray-200 bg-white">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-3 text-left text-xs font-bold text-gray-600">SL NO.</th>
              <th className="px-3 py-3 text-left text-xs font-bold text-gray-600">INITIATION DATE</th>
              <th className="px-3 py-3 text-left text-xs font-bold text-gray-600">REPORT NAME</th>
              <th className="px-3 py-3 text-left text-xs font-bold text-gray-600">EMAIL RECIPIENTS</th>
              <th className="px-3 py-3 text-left text-xs font-bold text-gray-600">DOWNLOAD LINK</th>
              <th className="px-3 py-3 text-left text-xs font-bold text-gray-600">ERROR</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {downloads.length === 0 ? (
              <tr>
                <td colSpan={9} className="text-center py-10 text-gray-400 text-lg">
                  No records found
                </td>
              </tr>
            ) : (
              downloads.map((download, idx) => (
                <tr key={download._id || idx} className="hover:bg-gray-50">
                  <td className="px-3 py-2">{idx + 1}</td>
                  <td className="px-3 py-2">
                    {download.createdAt
                      ? new Date(download.createdAt)
                          .toLocaleDateString("en-GB")
                          .replace(/\//g, "-")
                      : "N/A"}
                  </td>
                  <td className="px-3 py-2">{download.reportName || "N/A"}</td>
                 
                  <td className="px-3 py-2">{download.emailRecipients || "N/A"}</td>
                 <td className="px-3 py-2">
  {download.link ? (
    <a
      href={download.link}
      className="bg-green-100 text-green-700 font-medium px-3 py-1 rounded-lg shadow-sm border border-green-300 hover:bg-green-200 transition text-[13px]"
      target="_blank"
      rel="noopener noreferrer"
    >
      Click to open
    </a>
  ) : (
    <span className="flex items-center gap-2 text-yellow-500">
      <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
          fill="none"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        />
      </svg>
      Processing...
    </span>
  )}
</td>
                  <td className="px-3 py-2">
                    {download.error ? (
                      <span className="font-medium text-red-500">Yes</span>
                    ) : (
                      <span className="font-medium text-green-500">No</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LogViewer;
